import React from "react";
import {MenuItem} from "@mui/material";

export const GetAccountOwnerItems = (clientId) => {
    let items = [];
    if (clientId) {
        items.push(
            <MenuItem key={clientId} value={clientId}>
                Client
            </MenuItem>
        );
    }
    items.push(
        <MenuItem key={Number(process.env.REACT_APP_NEWCENT_CONTACT_ID)} value={Number(process.env.REACT_APP_NEWCENT_CONTACT_ID)}>
            Newcent
        </MenuItem>
    );
    return items;
}